export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "wordCounter": {
    "title": "字数统计器",
    "subtitle": "统计字数、字符数、句子数、段落数。分析关键词密度。",
    "privacy": "100% 本地处理",
    "noUpload": "无需上传",
    "inputLabel": "粘贴或输入文本",
    "placeholder": "在此粘贴文本开始分析...",
    "words": "字数",
    "wordSingular": "字",
    "wordsPlural": "字",
    "characters": "字符数",
    "noSpaces": "不含空格",
    "sentences": "句子数",
    "paragraphs": "段落数",
    "readingTime": "阅读时间",
    "avgWord": "平均长度",
    "longest": "最长",
    "keywordDensity": "关键词密度",
    "emptyHint": "开始输入或粘贴文本以查看统计信息"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 本工具完全在您的浏览器中本地处理所有数据。您的数据绝不会上传到任何服务器，确保完全的隐私与安全。"
    },
    "guide": {
      "title": "如何使用字数统计工具",
      "description": "为文章、论文、社交媒体帖子等获取即时文本统计信息。",
      "steps": [
        {
          "title": "粘贴或输入文本",
          "description": "在输入区域输入任意文本。工具会在您输入时实时更新统计数据，无需按任何按钮。"
        },
        {
          "title": "查看详细统计",
          "description": "一目了然地查看字数、字符数（含和不含空格）、句子数、段落数以及预估阅读时间。"
        },
        {
          "title": "分析关键词密度",
          "description": "向下滚动到关键词密度区域，查看出现频率最高的词汇。这对 SEO 优化和内容分析非常有用。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "实时统计字数、字符数、句子和段落数量",
        "基于成人平均阅读速度估算阅读时间",
        "关键词密度分析，助力 SEO 与写作洞察",
        "平均词长和最长词检测",
        "支持英文、中文及混合语言文本",
        "零数据上传 — 一切在浏览器本地完成"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "本工具支持中文文本吗？",
          "answer": "支持。字数统计使用 Unicode 感知逻辑，可正确统计中文字符、英文单词及混合语言内容。每个中文字符均计为一个字。"
        },
        {
          "question": "阅读时间是如何计算的？",
          "answer": "阅读时间基于成人平均每分钟约 200 个英文单词的阅读速度估算，其他语言采用 comparable 速率。这能让您快速了解内容阅读所需时长。"
        },
        {
          "question": "我的文本会被存储吗？",
          "answer": "不会。所有分析都在浏览器本地进行。关闭页面或刷新后文本即消失。我们不会存储、记录或传输您的任何内容。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "大小写转换",
          "url": "/text/case-converter",
          "description": "在大小写、首字母大写、全大写等格式之间转换文本。"
        },
        {
          "name": "Lorem Ipsum 生成器",
          "url": "/text/lorem-ipsum-generator",
          "description": "为设计和排版需求生成占位文本。"
        },
        {
          "name": "Markdown 编辑器",
          "url": "/text/markdown-editor",
          "description": "使用实时分屏编辑器编写和预览 Markdown。"
        }
      ]
    }
  }
};
